import { createAsyncAction } from 'typesafe-actions';
import { SpotifyUser } from './types';

export const spotifyInitUser = createAsyncAction(
  'spotify/user/init/REQUEST',
  'spotify/user/init/SUCCESS',
  'spotify/user/init/FAILURE',
)<void, SpotifyUser, unknown>();
